import React from "react";
import profile_Img from "../../Assets/Images/user.png";

const AllUserList = ({ key, users, handleSelectChat, selected }) => {
  return (
    <>
      <li
        className={`flex justify-between items-center rounded-md transition cursor-pointer`}
        key={key}
      >
        <label
          className={`flex justify-between items-center p-3 px-2 mt-1.5 flex-grow-1 rounded-md transition cursor-pointer`}
          htmlFor={users._id}
        >
          <div className="flex">
            <img
              src={users?.avtarImage || users?.userImage || profile_Img}
              alt={users?.name}
              className={`${
                users?.avtarImage || users?.userImage
                  ? "max-w-[46px] max-h-[46px] rounded-full min-w-[46px] min-h-[46px] object-cover object-center"
                  : "object-cover max-w-[46px] max-h-[46px] p-1 rounded-full"
              }`}
            />
            <div className="flex flex-col ml-2">
              <span className="font-semibold text-sm text-black pb-2 w-80 truncate">
                {users?.name}
              </span>
              <span className="text-xs font-normal text-[#7C7C7C] line-clamp-2 overflow-hidden text-ellipsis break-words">
                {(users?.privacy === "Everyone" ||
                  users?.privacy === "Friends") && (
                  <>
                    ({users?.countryCode?.includes('+') ? users?.countryCode : `+${users?.countryCode}`}) {users?.phone}
                  </>
                )}
              </span>
            </div>
          </div>

          <input
            name={users._id}
            id={users._id}
            type="checkbox"
            checked={selected}
            onChange={() => handleSelectChat(users)}
            className="border-gray-300 rounded h-5 w-5 ml-[-20px]"
          />
        </label>
      </li>
    </>
  );
};

export default AllUserList;
